import { EXISTING_CONTACT } from '@/components/forms/CreateNewBusinessForm/validationSchema';
import { splitName } from '@/utils/constants';
import { safelyParseDate } from '@/utils/date';

export const contactOrder = (contact) => (contact.isMainContact ? 1 : 0);

export const parseContactToInsight = (contact) => {
	// console.log('Firebase contact to insight', contact);

	const name = contact?.Name ?? contact?.Addressee ?? contact?.Contact ?? '';
	const { firstName, lastName } = splitName(name);
	const birthDate = contact?.BirthDate ? safelyParseDate(contact.BirthDate) : null;
	return {
		...contact,
		Id: contact?.Id,
		FirstName: firstName,
		LastName: lastName,
		Contact: name,
		[EXISTING_CONTACT]: Boolean(contact?.Id),
		BirthDate: birthDate,
		isMainContact: Boolean(contact?.isMainContact ?? contact?.IsPrimary),
		clientId: contact?.clientId,
	};
};
